var styles = {"wt-select-list":"_wt-select-list_y8d65h"};

export { styles as default };
